import type { ProjectEditProjectState, ProjectEditSliceState } from './projectEdit.types'

export const createEmptyProjectEditProjectState = (): ProjectEditProjectState => ({
  loading: false,
  loadError: null,
  projectTitle: '',
  savedProjectTitle: '',
  board: null,
  members: [],
  projectRoles: [],
  rolePermissionsDraft: {},
  savingProjectTitle: false,
  addingMemberUserId: null,
  updatingMemberUserId: null,
  removingMemberUserId: null,
  savingRolePermissionsId: null,
  deletingProject: false,
})

export const createInitialProjectEditState = (): ProjectEditSliceState => ({
  byProjectId: {},
})
